import { isShowZhiGuangTong } from '@components/LocalMerchant/ZhiGuangTong/util'
import { isSiDaProperty } from '@merchant-backend/util'
import { inject } from 'mobx-react'
import React from 'react'
import style from './index.module.less'

export default inject('pageStore')(props => {
  const _isShowZhiGuangTong = isShowZhiGuangTong()
  const { getPageConfig } = props.pageStore
  const { MULTI_STORE_IMG } = getPageConfig()
  return (
    <div className={style['data-center-wrap']}>
      {_isShowZhiGuangTong && (
        <div className="data-center">
          <h3>数据中心</h3>
          <p>
            大数据精准监控用户行为，全方位智能分析，辅助制定运营策略，快速获客
          </p>
          <img
            className="img-circle"
            src="https://qnm.hunliji.com/o_1d4hvpjio17v7uglo3o16cv1c4rj.png"
          />
          <img
            className="img-data"
            src="https://qnm.hunliji.com/o_1d4huqla1nkd1phv88flef1tbs2p.png"
          />
        </div>
      )}
      {!isSiDaProperty() && (
        <div className="yunying-guanli-wrap">
          <h3>运营管理</h3>
          <p>轻松管理线上店铺，降低运营成本</p>
          <div className="dianpu-liebiao">
            <img className="img-dianpu-liebiao" src={MULTI_STORE_IMG} />
            <img
              className="img-xiamen"
              src="https://qnm.hunliji.com/o_1d4i3te3o1r89nd81a217kr11t3t.png"
            />
            <img
              className="img-lijiang"
              src="https://qnm.hunliji.com/o_1d4i3usbcld5tj0n31e341g4012.png"
            />
            <img
              className="img-sanya"
              src="https://qnm.hunliji.com/o_1d4i3v3d51j97sv3jkg2ug144f17.png"
            />
            <img
              className="img-dalian"
              src="https://qnm.hunliji.com/o_1d4i3vcsi1jce1hkvdifeqm1bgv1c.png"
            />
          </div>
          <img
            className="img-user"
            src="https://qnm.hunliji.com/o_1d56blhso196u1o7osbt1iudjd09.png"
          />
        </div>
      )}
    </div>
  )
})
